import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiButtonModule} from '@snelstart/ui-button';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-berekening-premieZvw',
  standalone: true,
    imports: [CommonModule, SharedUiButtonModule],
  templateUrl: './tekst-berekening-premieZvw.component.html',
  styleUrl: './tekst-berekening-premieZvw.component.scss',
})
export class TekstBerekeningPremieZvwComponent implements OnInit {

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();


  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
    })
  }

}

